import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Mirror of backend/element.py: category -> Element rating row.
export const FAMILY = { casement: "casement", awning: "casement", crank: "casement", tilt_turn: "casement", fixed: "fixed",
  sliding_door: "sliding_door", pocket_door: "sliding_door", swing_door: "swing_door", sliding_window: "sliding_window",
  single_hung: "hung", double_hung: "hung" };
export const NOT_LISTED = "Element rating not listed";
const KEYS = ["u_value", "shgc", "glass_details"];

let cache = null;
export function useElement() {
  const [el, setEl] = useState(cache);
  useEffect(() => {
    if (!cache) api.get("/element").then((r) => { cache = r.data; setEl(r.data); }).catch(() => {});
  }, []);
  return el;
}
export const resetElementCache = (v) => { cache = v; };

export const categoryOf = (row) => row.component?.line?.category || row.component?.design_category || row.line_category || "";

// Patch that switches a quote row's series (server re-applies the same rules on save).
export function seriesPatch(row, series, el) {
  if (series === "standard") {
    const prev = row.series_prev || {};
    return { series, series_prev: {}, element_pct: null, element_rated: false,
      ...(Object.keys(prev).length ? { u_value: prev.u_value ?? null, shgc: prev.shgc ?? null, glass_details: prev.glass_details || "" } : {}) };
  }
  if (!el) return { series };
  const r = el.ratings?.[FAMILY[categoryOf(row)]] || {};
  const rated = r.u != null && r.shgc != null;
  const snap = Object.keys(row.series_prev || {}).length ? row.series_prev : Object.fromEntries(KEYS.map((k) => [k, row[k] ?? null]));
  return { series, series_prev: snap, element_rated: rated, glass_details: el.glass, ...(el.pct != null ? { element_pct: row.element_pct ?? el.pct } : {}),
    ...(rated ? { u_value: r.u, shgc: r.shgc } : {}) };
}
